<template>
  <div>
    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div><button type="button" class="btn btn-primary" style="margin-bottom:10px" v-on:click="uploadFilePopupClick()">Upload File</button></div>
          <div class="col-xs-12 col-md-12 col-lg-12">
              <vue-good-table
                mode="remote"
                styleClass="vgt-table good-table condensed striped"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :columns="columns"
                :rows="fileData"
                :totalRows="fileDataCount"
                  :pagination-options="{
                    enabled: true,
                    perPage: 15,
                    perPageDropdown: [10, 15, 20, 50, 100]
                }">
                <div slot="emptystate"><nv-empty-state icon="fa-folder-open-o" title="No files found" hint="Uploaded files will show up here." /></div>
                  <template slot="loadingContent">
                    <!-- Empty loading screen to disable default loading -->
                  </template>
                  <template slot="table-row" slot-scope="props">
                    <slot :props="props" />
                    <span v-if="props.column.field == 'created_at'">
                      {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                    </span>
                    <span v-show="showDownloadColumn" v-else-if="props.column.field == 'view'" @click="downloadFile(props.row.id)" id='download-link'>
                        <i class="fa fa-download" aria-hidden="true"></i>
                    </span>
                    <span v-else>{{props.formattedRow[props.column.field]}}</span>
                    
                  </template>    
              </vue-good-table>
            </div>
        </div>
      </div>
    </section>
    <div class="modal-backdrop" v-if="showUploadFileModel" id="upload">
      <div class="modal modal-md" style="height: 200px;max-width:800px">
        <div class="modal-header">
          <slot name="header">
            <h3>Upload File</h3>
          </slot>
        </div>
          <div style="margin: 0px 20px; overflow-y: auto; overflow-x: hidden; height: 100%;">
            <slot name="body">
              <div class="form-horizontal">
    
                <div class="form-group">
                  <label for="campaign" style="font-weight:500" class="col-sm-4 control-label radio-inline required">Upload file</label>

                  <div class="col-sm-8" style="margin-top: 7px">
                    <div>  
                      <input type="file" id="csvFile" accept=".gpg,.xlsx,.xls,.csv" @change="onFileChange" />
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="closeUploadModel">Cancel</button>
                <button type="button" class="btn btn-primary" @click="proceedUploadModel">Upload</button> 
              </div>
            </div>
          </div>
      </div>
    </div>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import api from '../../../utils/api'
import { formatDate, getSelectorValue } from '../../../utils/utilities'
import moment from 'moment'
import flatPickr from 'flatpickr'
import jwtDecode from 'jwt-decode'

export default {
  name: 'uploadTable',
  validations: {
    file: { required }
  },
  components: {
    flatPickr
  },
  async mounted () {
    this.loading = true
    const token = localStorage.getItem(process.env.CLIENT_SECRET) // get token from local storage
    const decoded = jwtDecode(token) // decode token
    const role = decoded && decoded.userRoles && decoded.userRoles[0]
    if (!role || !role === 'apa_user' || !role === 'audit_user') {
      this.showDownloadColumn = true
      this.columns.push(
        {
          label: 'Download',
          sortable: false,
          field: 'view'
        })
    }
    await this.fetchFiles()
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true,
      onClose: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          instance.setDate([selectedDates[0], selectedDates[0]], true)
        }
      }
    })
  },
  data () {
    return {
      formatDate: formatDate,
      loading: false,
      fileData: [],
      fileDataCount: 0,
      showUploadFileModel: false,
      file: null,
      tableQueryParams: {
        columnFilters: {},
        sort: {
          created_at: 'desc'
        },
        page: 1,
        perPage: 15
      },
      previousQueryParams: {},
      columns: [
        {
          label: 'File Name',
          sortable: true,
          field: 'file_name',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search File Name'
          }
        },
        {
          label: 'Uploaded On',
          sortable: true,
          field: 'created_at',
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range',
            filterFn: this.dateRangeFilter
          }
        }
      ],
      showDownloadColumn: false
    }
  },
  methods: {
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.fetchFiles()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.fetchFiles()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType
        }
      })
      this.fetchFiles()
    },
    onColumnFilter (params) {
      let appliedFilter = {}
      for (const key in params.columnFilters) {
        if (key === 'created_at') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['fromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)._d
            appliedFilter['toDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)._d
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.fetchFiles()
    },
    dateRangeFilter (data, filterString) {
      let dateRange = filterString.split('to ')
      let startDate = moment(dateRange[0], 'DD-MM-YYYY').unix() * 1000
      let endDate = moment(dateRange[1] || dateRange[0], 'DD-MM-YYYY').add(1, 'days').unix() * 1000
      return (data = Date.parse(data) >= startDate && Date.parse(data) <= endDate)
    },
    closeUploadModel () {
      this.file = null
      this.showUploadFileModel = false
    },

    uploadFilePopupClick () {
      this.showUploadFileModel = true
    },

    async fetchFiles (forceLoadData = false) {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      if (!forceLoadData && JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams)) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }
      try {
        const response = await api.buildRequest(`/uploadList`, 'POST', queryParams)
        this.previousQueryParams = queryParams
        this.fileData = response.data.payload.uploadedFiles
        this.fileDataCount = response.data.payload.uploadedFilesCount
        this.loading = false
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Failure',
          type: 'error',
          text: error.response ? error.response.data.payload.message : 'An error occurred'
        })
      }
    },

    onFileChange (e) {
      const file = e.target.files[0]
      let fileSize = file.size
      if (fileSize > 5000000) {
        this.$swal({
          type: 'error',
          text: 'File size should be less than 5MB'
        })
        return
      }
      this.file = file
    },

    async proceedUploadModel () {
      this.$v.file.$touch()
      if (this.$v.file.$invalid) {
        return
      }
      this.loading = true
      const formData = new FormData()
      formData.append('file', this.file)
      api.buildRequest(`fileUpload`, 'POST', formData)
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.$swal({
              type: 'success',
              text: 'File uploaded successfully'
            })
            this.closeUploadModel()
            this.fetchFiles(true)
          } else {
            this.$swal({
              type: 'error',
              text: response.data.payload.error || response.data.payload.message || 'An error occurred'
            })
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    downloadFile (fileId) {
      this.loading = true
      api.buildRequest(`downloadFile/${fileId}`, 'GET', null, null, 'blob')
        .then(response => {
          this.loading = false
          const contentDisposition = response.headers['content-disposition']
          const contentType = response.headers['content-type']
          const fileNameMatch = contentDisposition && contentDisposition.match(/filename=(.*)/)
          const fileName = fileNameMatch ? fileNameMatch[1] : 'file.csv'
          const blob = new Blob([response.data], { type: contentType })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', decodeURIComponent(fileName))
          document.body.appendChild(link)
          link.click()
        }).catch(error => {
          this.loading = false
          console.log('error: ', error)
          this.$swal({
            type: 'error',
            text: error.response ? error.response.data.payload.message : 'An error occurred'
          })
        })
    }
  }
}
</script>
<style>
.query-list-table-wrapper {
  min-height: 600px;
}
</style>


// WEBPACK FOOTER //
// uploadTable.vue?8f604ebe